var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M172.27 480.87c-49.61-10.53 97.46-112.28 182.89-97.8 50.65 8.58 127.44 95.5 162.01 180.28C545.63 633.13 564 376.88 892.6 105.86c106.44-87.78 163.44-94.1 163.39-79.05-.04 14.72-51.75 60.48-93.96 107.39-205.13 228.02-328.7 526.45-343.59 627.13-8.67 58.59-136.23 129.92-154.52 77.08-68.4-197.66-196.29-337.31-291.65-357.54z",
    style: {
      fill: "#00a500"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.41 1055.11H49.05c-17.14 0-31.05-13.9-31.05-31.05V132.71c0-17.14 13.9-31.05 31.05-31.05H601.5c17.14 0 31.05 13.9 31.05 31.05s-13.9 31.05-31.05 31.05H80.09v829.27h829.27V402.28c0-17.14 13.9-31.05 31.05-31.05s31.05 13.9 31.05 31.05v621.79c-.01 17.14-13.91 31.04-31.05 31.04z",
    style: {
      fill: "#303030"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.81d42f32b0eea5e87111278e80cfecc8.svg";
export { ForwardRef as ReactComponent };